const CoursesActionTypes = {
  GET_COURSES: 'GET_COURSES',
  GET_COURSES_SUCCESS: 'GET_COURSES_SUCCESS',
  GET_COURSES_FAILED: 'GET_COURSES_FAILED',
  GET_ALL_COURSES: 'GET_ALL_COURSES',
  GET_ALL_COURSES_SUCCESS: 'GET_ALL_COURSES_SUCCESS',
  GET_ALL_COURSES_FAILED: 'GET_ALL_COURSES_FAILED',
  GET_COURSE_DETAILS: 'GET_COURSE_DETAILS',
  GET_COURSE_DETAILS_SUCCESS: 'GET_COURSE_DETAILS_SUCCESS',
  GET_COURSE_DETAILS_FAILED: 'GET_COURSE_DETAILS_FAILED',
  GET_COURSES_APLLICANTS: 'GET_COURSES_APLLICANTS',
  GET_COURSES_APLLICANTS_SUCCESS: 'GET_COURSES_APLLICANTS_SUCCESS',
  GET_COURSES_APLLICANTS_FAILED: 'GET_COURSES_APLLICANTS_FAILED',
  ADD_COURSE: 'ADD_COURSE',
  ADD_COURSE_SUCCESS: 'ADD_COURSE_SUCCESS',
  ADD_COURSE_FAILED: 'ADD_COURSE_FAILED',
  ADD_FAILED: 'ADD_FAILED',
  DELETE_COURSE: 'DELETE_COURSE',
  DELETE_COURSE_SUCCESS: 'DELETE_COURSE_SUCCESS',
  DELETE_COURSE_FAILED: 'DELETE_COURSE_FAILED',
  UPDATE_COURSE: 'UPDATE_COURSE',
  DISABLES_COURSE: 'DISABLES_COURSE',
  UPDATE_COURSE_SUCCESS: 'UPDATE_COURSE_SUCCESS',
  UPDATE_COURSE_FAILED: 'UPDATE_COURSE_FAILED',
  SET_CURRENT: 'SET_CURRENT',
  CLEAR_CURRENT: 'CLEAR_CURRENT',
  CLEAR_STATUS: 'CLEAR_STATUS',
  CLEAR_ERROR: 'CLEAR_ERROR',
  SEARCH_COURSE: 'SEARCH_COURSE',
  SEARCH_COURSE_RESULTS: 'SEARCH_COURSE_RESULTS',
  FILTER_BY_STATUS: 'FILTER_BY_STATUS',
  FILTER_BY_ADMIN_LEVEL: 'FILTER_BY_ADMIN_LEVEL',
  SET_STATUS: 'SET_STATUS',
  DOWNLOAD_COURSE_TEMPLATE: 'DOWNLOAD_COURSE_TEMPLATE',
  DOWNLOAD_COURSE_TEMPLATE_SUCCESS: 'DOWNLOAD_COURSE_TEMPLATE_SUCCESS',
  DOWNLOAD_COURSE_TEMPLATE_FAILURE: 'DOWNLOAD_COURSE_TEMPLATE_FAILURE',
  BULK_COURSES_UPLOAD: 'BULK_COURSES_UPLOAD',
  BULK_COURSES_UPLOAD_SUCCESS: 'BULK_COURSES_UPLOAD_SUCCESS',
  BULK_COURSES_UPLOAD_FAILURE: 'BULK_COURSES_UPLOAD_FAILURE',
};

export { CoursesActionTypes };
